export const paths = {
  home: "/",
  mock: "/mock",
};
